import {
  GET_ANSWER_AGENT_PROFILE,
  GET_ANSWER_AGENT_PROFILE_SUCCESS,
  GET_ANSWER_AGENT_PROFILE_ERROR,
  QUOTE_FUNNEL_QUESTIONS,
  QUOTE_FUNNEL_QUESTIONS_SUCCESS,
  QUOTE_FUNNEL_QUESTIONS_ERROR,
  UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS,
  UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS_SUCCESS,
  UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS_ERROR,
  CREATE_QUOTE_FORM_VISIT_SUCCESS,
  CREATE_QUOTE_FORM_VISIT_ERROR,
  UPDATE_QUOTE_FORM_VISIT_SUCCESS,
} from "./actionTypes"

const initialState = {
  answer_agent_profile: null,
  answer_agent_profile_loading: false,
  answer_agent_profile_error: null,
  quote_funnel_questions: null,
  quote_funnel_questions_loading: false,
  quote_funnel_questions_error: null,
  quote_form_visit: null,
}

const QuoteFunnelAnswersAgentProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ANSWER_AGENT_PROFILE:
      return {
        ...state,
        answer_agent_profile_loading: true,
      }
    case GET_ANSWER_AGENT_PROFILE_SUCCESS:
      return {
        ...state,
        answer_agent_profile_loading: false,
        answer_agent_profile: action.payload,
        answer_agent_profile_error: null
      }
    case GET_ANSWER_AGENT_PROFILE_ERROR:
      return {
        ...state,
        answer_agent_profile_loading: false,
        answer_agent_profile_error: action.payload
      }
    case QUOTE_FUNNEL_QUESTIONS:
      return {
        ...state,
        quote_funnel_questions_loading: !action?.payload?.reducer_update_not_required
      }
    case QUOTE_FUNNEL_QUESTIONS_SUCCESS:
      return {
        ...state,
        quote_funnel_questions_loading: false,
        quote_funnel_questions: action.payload,
        quote_funnel_questions_error: null,
        quote_form_visit: action.payload?.latest_visit
      }
    case QUOTE_FUNNEL_QUESTIONS_ERROR:
      return {
        ...state,
        quote_funnel_questions_loading: false,
        quote_funnel_questions_error: action.payload
      }
    case UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS:
      return {
        ...state,
        quote_funnel_questions_loading: true,
      }
    case UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS_SUCCESS:
      return {
        ...state,
        quote_funnel_questions_loading: false,
        quote_funnel_questions: action.payload
      }
    case UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS_ERROR:
      return {
        ...state,
        quote_funnel_questions_loading: false,
        quote_funnel_questions_error: action.payload
      }
    case CREATE_QUOTE_FORM_VISIT_SUCCESS:
      return {
        ...state,
        quote_form_visit: action.payload
      }
    case CREATE_QUOTE_FORM_VISIT_ERROR:
      return {
        ...state,
        quote_form_visit: null
      }
    case UPDATE_QUOTE_FORM_VISIT_SUCCESS:
      return {
        ...state,
        quote_form_visit: action.payload?.latest_visit
      }
    default:
      return state
  }
}

export default QuoteFunnelAnswersAgentProfileReducer